import { LazyLoadable } from '../../../lazyLoadable';
import { MarkdownEditorProps } from './MarkdownEditor';

interface Exports {
    MarkdownEditor: typeof import('./MarkdownEditor');
}

export const MarkdownEditorField = LazyLoadable<MarkdownEditorProps, Exports, {}>({
    loader: {
        MarkdownEditor: async () => import(/* webpackChunkName: "MarkdownEditor" */ './MarkdownEditor'),
    },
    render(loaded, props) {
        const LoadedMarkdownEditor = loaded.MarkdownEditor.default;
        return <LoadedMarkdownEditor {...props} />;
    },
});
